import React from 'react';
import { connect } from 'react-redux';

import QuestionHOC from './QuestionHOC';

function AppointmentDetails({ item, index }) {
  return <QuestionHOC item={item} index={index}>
    <div className="row">
      <div className="col">
        <p className="m-0"><strong>Chart ID:</strong> 999999</p>
        <p className="m-0"><strong>Patient Name:</strong> Jane Doe</p>
        <p className="m-0"><strong>Date of Birth:</strong> 10/25/1976</p>
      </div>
      <div className="col">
        <p className="m-0"><strong>Appointment Date:</strong> 07/07/2020</p>
        <p className="m-0"><strong>Provider:</strong> Dr. Trevor Wang (example)</p>
        <p className="m-0"><strong>Location:</strong> Spine Center</p>
      </div>
    </div>
  </QuestionHOC>
}

export default connect()(AppointmentDetails);